import { Fragment } from 'react'
import { useLocation } from 'react-router-dom'

import { hasSupportAppPermission } from 'support/helpers/utilities'
import { NavHR } from 'components/navigation/Nav'
import NavLink from 'components/navigation/NavLink'
import useAuth from 'hooks/use-auth'

/**
 * Stored here to avoid our security checks from leaving the `/support` directory
 */
const SupportAppNavLink = () => {
  const { session } = useAuth()
  const { pathname: currentPathname } = useLocation()

  return hasSupportAppPermission(session) ? (
    <Fragment>
      <NavHR />
      <NavLink
        active={
          currentPathname.startsWith('/support/') ||
          currentPathname.startsWith('/supportnew/')
        }
        data-test="support-app-link"
        icon="support"
        text="Support App"
        to="/support"
      />
    </Fragment>
  ) : null
}

export default SupportAppNavLink
